module.exports = __webpack_public_path__ + "static/media/CNT_Tech_Illustrationedited_Wifi-01.b4122050.svg";